import { Grid } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form';
import { useLocation } from 'react-router';
import { RouterDOM, FnAxios, FnDialog, I18n } from 'utilities/utilities';
import { BtnBack, BtnSave } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import moment from 'moment';
import { APIStatusCode, I18NextNs } from 'enum/enum';
import TableActualExpenseSection from './TableActualExpenseSection';
import { GetMenuPermissionParamRoute } from 'utilities/SystemFunction';

export const ProviderExpenseActual = React.createContext(null);

const FundExpenseActualForm = () => {
    //#region Hook
    const Router = RouterDOM();
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    const location = useLocation();
    // #endregion

    const objParamPath = useMemo(() => {
        const ParamId = new URLSearchParams(location.search).get("strParam");
        const ParamPrs = 2;
        return { ParamId, ParamPrs }
    }, [location.search])

    //#region State / Usememo
    const arrMonth = useMemo(() => ["ม.ค.", "ก.พ.", "มี.ค.", "รวม", "เม.ย.", "พ.ค.", "มิ.ย.", "รวม", "ก.ค.", "ส.ค.", "ก.ย.", "รวม", "ต.ค.", "พ.ย.", "ธ.ค.", "รวม", "รวมปีปฏิทิน"], [])
    const [isPermission, setIsPermission] = useState<boolean>(false);
    // const [isView, setIsView] = useState(false)
    const [lstExpense, setLstExpense] = useState([] as any)
    const [lstProject, setLstProject] = useState([] as any)
    const [lstSectionSummary, setLstSectionSummary] = useState([] as any)
    // #endregion

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            dYear: null,
            isSaveVersion: null,
            lstExpensePlan: [] as any
        }
    });
    // #endregion

    useEffect(() => {
        GetMenuPermissionParamRoute("/FundExpenseActualList", AxiosFn, setIsPermission, DialogFn);
    }, []);


    const getOptionInitialData = async () => {
        if (!objParamPath.ParamId) return;

        DialogFn.BlockUI();
        await AxiosFn.Get(`FundExpenseActual/GetFormInfoFundExpenseActual`, { sID: objParamPath.ParamId }, (result: { objResult: any; }) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            if (objResult) {
                form.setValue("dYear", moment().set('year', objResult.nYear))
                form.setValue("lstExpensePlan", objResult.lstExpensePlanOnAdd)
                setLstExpense(objResult.lstMasterSection)
                setLstProject(objResult.lstProjectInSection)
                setLstSectionSummary(objResult.lstMasterSection)
            }
        }, null, () => DialogFn.UnBlockUI());
    };

    const handleSelectYear = async (eValue: moment.MomentInput) => {
        form.clearErrors();
        if (!eValue) {
            setLstExpense([])
            form.setValue("lstExpensePlan",[])
            setLstProject([])
            setLstSectionSummary([])
            return;
        }
        DialogFn.BlockUI();
        let nYear = parseInt(moment(eValue).format('YYYY'));
        await AxiosFn.Get(`FundExpenseActual/GetInitFormExpenseActual`, { nYear: nYear }, (result) => {
            DialogFn.UnBlockUI();
            if (result.nStatusCode === 203) {
                DialogFn.Warning(result.sMessage);
                setLstProject([])
                setLstExpense([])
                setLstSectionSummary([])
                form.setValue("dYear", null)
                return;
            }

            let objResult = result.objResult;
            setLstExpense(objResult.lstMasterSection)
            form.setValue("lstExpensePlan", objResult.lstExpensePlanOnAdd)
            setLstProject(objResult.lstProjectInSection)
            setLstSectionSummary(objResult.lstMasterSection)

        }, null, () => DialogFn.UnBlockUI());
    };

    const handleSubmitExpenseActual = () => {

        let objParam = {
            "sID": objParamPath.ParamId,
            "nYear": form.getValues("dYear") ? parseInt(moment(form.getValues("dYear")).format('YYYY')) : null,
            "lstExpenseSection": lstExpense,
            "lstProjectSection": lstProject,
            "lstExpensePlanAdd": form.getValues("lstExpensePlan") || []
        }

        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            AxiosFn.Post(`FundExpenseActual/OnSubmitFundExpenseActual`, objParam, (result: { nStatusCode: number; sMessage: any; }) => {
                if (result.nStatusCode === APIStatusCode.Success) {
                    DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                        gotoBack();
                    });
                } else {
                    DialogFn.Warning(result.sMessage);
                }
            });
        });
    }

    const gotoBack = () => {
        Router.GoToPage("/FundExpenseActualList")
    }

    
    const calIndexOld = (index: number) => {
        if (index === 2) {
            return 1
        }
        else if (index === 5) {
            return 2
        }
        else if (index === 8) {
            return 3
        }
        return 4
    }

    const objActualProvider = React.useMemo(() => (
        {
            arrMonth,
            isView : !isPermission,
            form,
            lstExpense,
            setLstExpense,
            lstProject,
            setLstProject,
            lstSectionSummary,
            setLstSectionSummary,
            calIndexOld
        }
    ), [arrMonth, form, isPermission, lstExpense, lstProject, lstSectionSummary]);

    useEffect(() => {
        getOptionInitialData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <ProviderExpenseActual.Provider value={objActualProvider} >
            <FormProvider {...form}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={3}>
                        <DatePickerItem
                            id={`dYear`}
                            name={`dYear`}
                            label={`ประจำปี`}
                            required
                            fullWidth
                            disabled={!isPermission || !!objParamPath.ParamId}
                            IsYearPicker
                            format='YYYY'
                            onChange={(eValue) => handleSelectYear(eValue)}
                        />
                    </Grid>
                    {lstExpense.length === 0 ?
                        <Grid item xs={12}>
                            <Grid container justifyContent={"center"} >
                                <Grid item >
                                    ไม่พบข้อมูล
                                </Grid>
                            </Grid>
                        </Grid>
                        :
                        <Grid item xs={12}>
                            <TableActualExpenseSection/>
                        </Grid>
                    }

                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={2}
                            justifyContent={"space-between"}
                            alignItems={"start"}
                        >
                            <Grid item>
                                <BtnBack id={"btnback"} onClick={() => gotoBack()} />
                            </Grid>
                            {isPermission && <Grid item>
                                <BtnSave
                                    id={"btnsave"}
                                    onClick={form.handleSubmit(() => handleSubmitExpenseActual())}
                                />
                            </Grid>}
                        </Grid>
                    </Grid>
                </Grid>
            </FormProvider>

        </ProviderExpenseActual.Provider>
    )
}

export default FundExpenseActualForm


export const arrMock = [
    {
        "name": "nM1",
        "nOrder": 1,
        "value": null
    },
    {
        "name": "nM2",
        "nOrder": 2,
        "value": null
    },
    {
        "name": "nM3",
        "nOrder": 3,
        "value": null
    },
    {
        "name": "nM4",
        "nOrder": 4,
        "value": null
    },
    {
        "name": "nM5",
        "nOrder": 5,
        "value": null
    },
    {
        "name": "nM6",
        "nOrder": 6,
        "value": null
    },
    {
        "name": "nM7",
        "nOrder": 7,
        "value": null
    },
    {
        "name": "nM8",
        "nOrder": 8,
        "value": null
    },
    {
        "name": "nM9",
        "nOrder": 9,
        "value": null
    },
    {
        "name": "nM10",
        "nOrder": 10,
        "value": null
    },
    {
        "name": "nM11",
        "nOrder": 11,
        "value": null
    },
    {
        "name": "nM12",
        "nOrder": 12,
        "value": null
    }
];